import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import type { IGigComplianceRow } from '@/components/agent/gig-compliance/types';
import type { IComplianceTableConfig } from '@/types/contracts';

import {
  CardContainer,
  HeaderLabel,
  Row,
  RowCell,
  RowLabelCell,
  RowsContainer,
  RowsLabelsContainer,
} from '@/components/agent/gig-compliance/ComplianceTable.styles';
import { ComplianceTableWeekSelector } from '@/components/agent/gig-compliance/ComplianceTableWeekSelector';
import { LoaderWrapper } from '@/components/common';
import { WeeksCardSkeleton } from './WeeksCard.skeleton';

interface IProps {
  tableConfig: IComplianceTableConfig;
  rowsToDisplay: IGigComplianceRow[];
}

const WeeksCard = ({ rowsToDisplay, tableConfig }: IProps): React.ReactElement => {
  const { t } = useTranslation();
  const isLoading = rowsToDisplay.length === 0;

  return (
    <WeeksCardContainer className="hide-on-mobile" width={tableConfig.week.width}>
      <LoaderWrapper className="h-100" isLoading={isLoading} loader={<WeeksCardSkeleton />}>
        <HeaderLabel>
          {t`gigCompliance.complianceTable.labelWeek`}
          <RowsLabelsContainer>
            <RowLabelCell>{!!rowsToDisplay.length && <ComplianceTableWeekSelector />}</RowLabelCell>
          </RowsLabelsContainer>
        </HeaderLabel>
        <RowsContainer
          colorOne={tableConfig.week.colorOne}
          colorTwo={tableConfig.week.colorTwo}
          colorText={tableConfig.week.colorText}
        >
          {rowsToDisplay.map(row => (
            <Row key={row.weekSpan}>
              <RowCell>{row.weekSpan}</RowCell>
            </Row>
          ))}
        </RowsContainer>
      </LoaderWrapper>
    </WeeksCardContainer>
  );
};

export { WeeksCard };

const WeeksCardContainer = styled(CardContainer)`
  position: relative;
  overflow: visible;
`;
